import { themes } from '@electricjs/arc';
import { DefaultTheme } from 'styled-components';

/**
 * isolved1 theme - Extends Electric (light) with isolved brand colors
 *
 * TODO: Fill in the isolved color tokens below.
 */
export const ISOLVED1_THEME: DefaultTheme = {
  ...themes.ELECTRIC,
  colors: {
    ...themes.ELECTRIC.colors,
    // ── isolved1 tokens ──
    'colorV2-primary': '#00A6DA', // Text label and caret color
    'colorV2-primary-dark': '#0F23B6', //Highlighted Text Color
    'colorV2-primary-darkest': '#0F23B6', //Highlighted Button Color
    'colorV2-primary-light': '#0F23B6', //Hover Outline Color
    'colorV2-primary-lightest': '#FFFFFF', //Tab fill color
  },
  name: 'isolved1',
};

/**
 * isolved2 theme - Extends Electric Dark with isolved brand colors
 *
 * TODO: Fill in the isolved color tokens below.
 */
export const ISOLVED2_THEME: DefaultTheme = {
  ...themes.ELECTRIC,
  colors: {
    ...themes.ELECTRIC.colors,
    'colorV2-primary': '#E50082', // Text label and caret color
    'colorV2-primary-dark': '#EBA400', //Highlighted Text Color
    'colorV2-primary-darkest': '#EBA400', //Highlighted Button Color
    'colorV2-primary-light': '#EBA400', //Hover Outline Color
    'colorV2-primary-lightest': '#FFFFFF', //Tab fill color
  },
  name: 'isolved2',
};
